import { Divider, Typography } from "antd";
import React from "react";
import AddBulkScan from "../../../components/Comman/BulkInwardOutward/AddBulkScan";
import "../../../styles/global-ui.css";

const Wash_BulkOutwardPage = ({ userData }) => {
  return (
    <div className="page-container">
      {/* 🔹 Header */}
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
              Washing Center Bin Bulk Outward
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            Scan, review, and send multiple bins from washing center
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <AddBulkScan
        title="Bin Bulk Outward"
        userData={userData}
        type="outward"
      />
    </div>
  );
};

export default Wash_BulkOutwardPage;